module.exports = __webpack_public_path__ + "media/images/icon__arrow-left@2x-be78936b9c07f60370e195aa71a3a231.png";